// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"e8bb7a71","332":"8e593086"}[chunkId] + ".chunk.js";
};